import { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
} from "@mui/material";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useTranslation } from "react-i18next";

const CalendarCheckbox = ({
  selectedClient,
  selectedDateCalendar,
  setSelectedDateCalendar,
  openCalendar,
  setOpenCalendar,
}) => {
  const { t } = useTranslation();

  // Open dialog when openCalendar is true
  useEffect(() => {
    if (openCalendar) {
      setOpenCalendar(true);
    }
  }, [openCalendar, setOpenCalendar]);

  // Function to close the dialog
  const handleClose = () => {
    setOpenCalendar(false);
  };

  // Function to handle date selection
  const handleDateChange = (date) => {
    setSelectedDateCalendar(date);
    setOpenCalendar(false); // Close dialog after selecting a date
  };

  return (
    <Dialog
      open={openCalendar}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth

    >
      <DialogTitle sx={{ textAlign: "center" }}>
        {t("Select Earlier Date")} ({selectedDateCalendar ? selectedDateCalendar.getFullYear() : new Date().getFullYear()})
      </DialogTitle>
      <DialogContent dividers>
        <Grid container>
          {Array.from({ length: 12 }, (_, monthIndex) => (
            <Grid item xs={12} sm={4} md={3} key={monthIndex}>
              <Calendar
                onChange={handleDateChange}
                value={selectedDateCalendar || new Date()}
                activeStartDate={
                  new Date(selectedDateCalendar?.getFullYear() || new Date().getFullYear(), monthIndex, 1)
                }
                view="month"
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <Button onClick={handleClose} color="primary">
        {t("Close")}
      </Button>
    </Dialog>
  );
};

export default CalendarCheckbox;